module.exports = __webpack_public_path__ + "static/media/manual_de_servicio.15884aca.pdf";